module.exports = __webpack_public_path__ + "play.73bf9869.png";